module.exports = __webpack_public_path__ + "static/images/dialog-bg.dee739c.png";